//@flow
import { HiverAxios,unsavedChanges ,showMessage, sendTrackingEvent} from 'h-commons';
import { toast } from 'react-toastify';
import { TEMPLATE_LOAD, TEMPLATE_INIT_LOAD ,
            GET_BUSINESS_HOUR_TEMPLATES,
            UPDATE_BUSINESS_HOUR_TEMPLATE_DONE,
            GET_BUSINESS_HOUR_TEMPLATE_DATA
        }  from './types';
import { history } from '../../common/helpers';
import { fetchDashboardDetails } from '../../dashboard/actions';
import { CHAT_CHANNEL } from '../../channelAdmin/constants/channelAdmin.const';
import { API_RESPONSE_ERROR_MESSAGE } from '../constants';
const SM_ROOT = '/api';

function fetchBusinessHourTemplates(params) {      
    return (dispatch) => {
        HiverAxios({
            url: `${SM_ROOT}/businesshours`,
            type: 'GET',
            params,
            callback: (response) => {
                response = response.data;
                dispatch({
                    type: GET_BUSINESS_HOUR_TEMPLATES,
                    payload:response
                })
            },
            onfail: (error) => {
                dispatch({
                    type: GET_BUSINESS_HOUR_TEMPLATES,
                    payload:[]
                });
            }
        })
    }
    
}


function fetchsBusinessHourTemplateData(templateid,params) {      
    return (dispatch) => {
        HiverAxios({
            url: `${SM_ROOT}/businesshours/${templateid}`,
            type: 'GET',
            params,
            callback: (response) => {
                response = response.data;
                
                dispatch({
                    type: TEMPLATE_LOAD,
                    payload:response
                })
            },
            onfail: (error) => {
                showMessage({
                    message: API_RESPONSE_ERROR_MESSAGE,
                    type:'error'
                });
                dispatch({
                    type: TEMPLATE_LOAD,
                    payload:[]
                });
            }
        })
    }
    
}

function goBackToBusinessHoursList() {
    const BusinessHoursListUrl = `/app/settings/business-hours`;
    history.push(BusinessHoursListUrl);
}

function filterSlotData (slots) {
    for (var key in slots) {
        let slot = slots[key];
        if(slot && !slot.length){
            delete slots[key];
        }
    }
    return slots;
}

function filterHolidayData (holidays,showholidays) {
    if(!holidays.length){
        return 0;
    }
    return showholidays;
}

function createBusinessHourTemplate(params) {
    params.slots = filterSlotData(params.slots);
    params.showholidays = filterHolidayData(params.holidays, params.showholidays);
    return (dispatch) => {
        HiverAxios({
            url: `${SM_ROOT}/businesshours`,
            type: 'POST',
            params,
            callback: (response) => {
                dispatch(unsavedChanges(false)).then(goBackToBusinessHoursList);
                response = response.data;
                if(response.inserted){
                    dispatch({
                        type: UPDATE_BUSINESS_HOUR_TEMPLATE_DONE
                    })
                    dispatch(fetchDashboardDetails());
                    showMessage({
                        message:'Business Hour Template successfully created',
                        type:'success'
                    });
                    sendTrackingEvent('setupBH');
                    return;
                }else if(response.message == 'duplicate entry found'){
                    response.message ="Business Hour Template with same name exist"
                }
                showMessage({
                    message:response.message,
                    type:'error'
                });
            },
            onfail: (error) => {
                dispatch(unsavedChanges(false)).then(goBackToBusinessHoursList);
                showMessage({
                    message: API_RESPONSE_ERROR_MESSAGE,
                    type:'error'
                });
            }
        })
    }
}

function editBusinessHourTemplate(templateid, params, onChatError) {
    params.slots = filterSlotData(params.slots);
    params.showholidays = filterHolidayData(params.holidays, params.showholidays);
    return (dispatch) => {
        HiverAxios({
            url: `${SM_ROOT}/businesshours/${templateid}`,
            type: 'PUT',
            params,
            callback: (response) => {
                dispatch(unsavedChanges(false)).then(goBackToBusinessHoursList);
                response = response.data;
                if(response.inserted){
                    dispatch({
                        type: UPDATE_BUSINESS_HOUR_TEMPLATE_DONE
                    })
                    showMessage({
                        message:'Business Hour Template successfully updated',
                        type:'success'
                    });
                    return;
                }
                showMessage({
                    message:response.message,
                    type:'error'
                });
            },
            onfail: (error) => {
                if (error?.response?.data?.type === CHAT_CHANNEL) {
                    if (typeof onChatError === 'function') onChatError();
                } else {
                    dispatch(unsavedChanges(false)).then(goBackToBusinessHoursList);
                    showMessage({
                        message: API_RESPONSE_ERROR_MESSAGE,
                        type:'error'
                    });
                }
            }
        })
    }
}

function deleteBusinessHourTemplate(templateid, callback) {
    return (dispatch) => {
        HiverAxios({
            url: `${SM_ROOT}/businesshours/${templateid}`,
            type: 'DELETE',
            params: null,
            callback: (response) => {
                response = response.data;
                let success = true;
                    if(response.deleted){
                        dispatch({
                            type: UPDATE_BUSINESS_HOUR_TEMPLATE_DONE,
                            payload:response
                        });
                        dispatch(fetchDashboardDetails());
                        showMessage({
                            message:'Business Hour Template successfully deleted',
                            type:'success'
                        });
                    }else{
                        showMessage({
                            message: API_RESPONSE_ERROR_MESSAGE,
                            type:'error'
                        });
                        success=false;
                    }
                    callback && callback(success);
            },
            onfail: (error) => {
                showMessage({
                    message: API_RESPONSE_ERROR_MESSAGE,
                    type:'error'
                });
                callback(false);
            }
        })
    }
}


const loadTemplateData = (templateData) => ({
    type: templateData ? TEMPLATE_LOAD : TEMPLATE_INIT_LOAD, 
    data: templateData
})


export {fetchBusinessHourTemplates,
    loadTemplateData ,
    createBusinessHourTemplate,
    fetchsBusinessHourTemplateData,
    editBusinessHourTemplate,
    deleteBusinessHourTemplate
};
